module.exports = __webpack_public_path__ + "static/dragon_turtle-5d26ac5b54ce5c8968594dfd0528b308.jpg";